// Toggle — small pill switch. This codebase didn't have one; checkboxes
// were standing in for on/off settings, which read as cramped/unclear.

export function Toggle({ checked, onChange, disabled }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      style={{
        width: 34, height: 19, borderRadius: 999, border: 'none', padding: 2,
        background: checked ? 'var(--color-primary)' : 'var(--border-default)',
        cursor: disabled ? 'default' : 'pointer', opacity: disabled ? 0.6 : 1,
        display: 'inline-flex', alignItems: 'center', flexShrink: 0,
        transition: 'background 150ms var(--ease-default)',
      }}
    >
      <span style={{
        width: 15, height: 15, borderRadius: 999, background: '#fff',
        transform: checked ? 'translateX(15px)' : 'translateX(0)',
        transition: 'transform 150ms var(--ease-default)',
        boxShadow: '0 1px 2px rgba(0,0,0,0.25)',
        display: 'block',
      }} />
    </button>
  );
}
